import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  searchResult: undefined,
  companiesList: undefined,
  productsList: undefined,
  provisioningTypes: undefined

}

export default {
  state,
  actions,
  getters,
  mutations
}
